<template>
  <mc-container :title="title">
    <div class="mc-list-fold">
      <ul
          class="mc-list-fold__ul"
          :style="{
            height: foldHeight
          }">
        <slot></slot>
        <!--<li class="mc-list-fold__item"-->
            <!--v-for="item in listData" >-->
          <!--{{item}}-->
        <!--</li>-->
      </ul>
      <footer
          class="mc-list-fold__footer"
          v-if="maxLine > minLine">
        <p>
          <template v-if="fold">查看全部</template>
          <template v-else>收起</template>
        </p>
        <span
            @click="_toggle"
            :class="{
              'is-open': fold,
              'is-close': !fold
            }">
          <i class="fa fa-angle-up"></i>
        </span>
      </footer>
    </div>
  </mc-container>
</template>
<script type="text/ecmascript-6">
  import McContainer from './base-container'
  export default {
    name: 'mcBaseListFold',
    components: {
      McContainer
    },
    props: {
      title     : String,
      maxLine   :{
        type: [Number, String],
        default: 5
      },
      minLine   : {
        type: [Number, String],
        default: 5
      }
    },
    data(){
      return {
        fold: true,
        minHeight: this.minLine * 22 + 'px',
        maxHeight: this.maxLine * 22 + 'px'
      }
    },
    computed: {
      foldHeight(){
        return this.fold ? this.minHeight : this.maxHeight
      }
    },
    created(){
      if(this.maxLine > this.minLine){
        this.fold = true
      }else{
        this.fold = false
      }
    },
    methods:{
      _getValue(item){
        if(typeof item === 'object'){
          return item.value
        }else if( typeof item === 'string'){
          return item
        }
      },
      _toggle(){
        this.fold = !this.fold;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base-list-fold.vue